import axios from 'axios'
import userStore from '~/redux/user/store'
import { getToken } from '~/redux/user/tokens'

export function getBillingToken(stripeToken) {
    var user = userStore.getState().user

    return getToken().then(token => axios({
      url: `/payments/stripe/validate_stripe_customer`,
      baseURL: window.settings.apiBaseUrl,
      method: 'POST',
      params: { site: window.settings.internalName, timestamp: new Date().getTime(), platform: 'web_browser' },
      headers: { 
        'Authorization': token,
        'x-api-key': window.settings.baseAPIKey
      },
      data: { token: stripeToken.id, email: user && user.email }
    })).then(r => {
      var status = r.data.cardStatus
      if (status.address_zip_check !== 'pass' && status.address_zip_check !== 'unavailable')
        throw new Error('Your zip code is invalid')
      if (status.cvc_check !== 'pass' && status.cvc_check !== 'unavailable')
        throw new Error('Your CVC is invalid')

      return {
        stripeToken: stripeToken,
        requestId: r.data.requestId
      }
    })
  }
